import React, { useState } from "react";
import { Button, Col } from "antd";
import moment from "moment";
import "moment/locale/de";

type TuerchenContent = {
  frage: string;
  zu_gewinnen_kurz: string;
  zu_gewinnen_bild_url: string;
};

type TuerchenProps = {
  day: number;
  onClick?: () => void;
  onTeilnahmeClick?: () => void;
  defaultOpen?: boolean;
  allowTeilnahme?: boolean;
  content?: TuerchenContent;
  designName: string;
  isBig: boolean;
  currentDate: moment.Moment;
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
  xxl: number;
};

const Tuerchen = ({
  day,
  onClick,
  defaultOpen,
  allowTeilnahme,
  onTeilnahmeClick,
  content,
  designName,
  isBig,
  currentDate,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
}: TuerchenProps) => {
  const isTuerchenClickable =
    (currentDate.date() >= day && currentDate.month() === 11) ||
    content != null;

  const [isTuerchenOpen, setIsTuerchenOpen] = useState(defaultOpen || false);

  const handleClick = () => {
    setIsTuerchenOpen(!isTuerchenOpen);
    if (onClick) {
      onClick();
    }
  };

  return (
    <Col
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      xxl={xxl}
      className={`kalender-tuerchen-container ${isTuerchenOpen ? "open" : ""} ${
        !isTuerchenClickable ? "disabled" : ""
      } ${isBig ? "big" : ""}`}
      onClick={isTuerchenClickable ? handleClick : undefined}
    >
      <div className="inhalt">
        {!isBig && <div className="tuerchen-nummer">{day}</div>}

        {content && content.zu_gewinnen_bild_url && (
          <div className="bild">
            <img
              src={content.zu_gewinnen_bild_url}
              alt="Bild für Gewinnspiel"
            />
          </div>
        )}
        <div className="text">{content && content.zu_gewinnen_kurz}</div>
        {allowTeilnahme && (
          <>
            <Button
              size="large"
              type="link"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (onTeilnahmeClick) onTeilnahmeClick();
              }}
              className="teilnehmen-button"
            >
              Jetzt teilnehmen!
            </Button>
          </>
        )}
        <div className="tuerchen">
          <img
            src={`${process.env.PUBLIC_URL}/img/calendar/${designName}/${day}.png`}
            title={`Tür ${day}`}
            alt={`Tür ${day}`}
            key={day}
          />
        </div>
      </div>
    </Col>
  );
};

export default Tuerchen;
